export default __webpack_public_path__ + "static/media/IconDesc_XmasBall_Red.256.567a03df.png";